type ProductLike = {
  id?: string;
  productId?: string;
  stampCardRuleId?: string;
};

export function computeStampcardFormValues(
  stampcardProducts: ProductLike[] | null,
  productsInBasket: ProductLike[]
): Record<string, string> {
  return (stampcardProducts ?? productsInBasket).reduce<Record<string, string>>(
    (acc, product) => {
      if (product.stampCardRuleId) {
        acc[product.stampCardRuleId] =
          "id" in product && product.id
            ? product.id
            : (product as { productId: string }).productId;
      }
      return acc;
    },
    {}
  );
}
